const METHODS = [
  'Cash',
  'Check',
  'ACH',
  'Wire',
  'Credit Card',
];

export default METHODS;
